import React from "react";
import { AgentCommand } from "../../../utils/agentCommands";

interface AgentCommandMenuProps {
  visible: boolean;
  commands: AgentCommand[];
  onSelect: (cmd: AgentCommand) => void;
}

const AgentCommandMenu: React.FC<AgentCommandMenuProps> = ({ visible, commands, onSelect }) => {
  if (!visible || commands.length === 0) return null;

  return (
    <div className="eai-card absolute bottom-full left-0 z-50 mb-1 w-full overflow-hidden p-1 sm:w-1/2">
      {commands.map((cmd) => (
        <button
          key={cmd.command}
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(cmd);
          }}
          className="eai-menu-item flex w-full items-center gap-3 text-left"
        >
          <span className="text-sm font-medium text-eai-cta-primary">{cmd.label}</span>
          <span className="text-sm text-eai-ink-subtle">{cmd.description}</span>
        </button>
      ))}
    </div>
  );
};

export default AgentCommandMenu;
